export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const PERSIST_REHYDRATE = 'persist/REHYDRATE';

export const TITLEHEADER_CHANGE = '';

export const DATALICENCA_CHANGE = '';
